import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["action"]
const _hoisted_2 = ["value"]
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "gfu-currency-selector" }
const _hoisted_5 = ["label"]
const _hoisted_6 = ["value", "selected"]
const _hoisted_7 = ["label"]
const _hoisted_8 = ["value", "selected"]
const _hoisted_9 = {
  key: 0,
  class: "gfu-currency-selector__dropdown",
  role: "listbox",
  "aria-expanded": "true",
  "data-qa": "currency-selector:CurrenciesList"
}
const _hoisted_10 = {
  key: 0,
  class: "gfu-currency-selector-label",
  "data-qa": "currency-selector:CheckoutCurrency"
}
const _hoisted_11 = ["onClick", "onKeydown", "data-qa"]
const _hoisted_12 = {
  class: "gfu-currency-selector-label",
  "data-qa": "currency-selector:DisplayCurrencies"
}
const _hoisted_13 = ["onClick", "onKeydown", "data-qa"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_click_outside = _resolveComponent("click-outside")
  const _component_change_display_currency_modal = _resolveComponent("change-display-currency-modal")

  return (_ctx.isCurrencySelectorVisible && _ctx.currentSelectedCurrencyId)
    ? (_openBlock(), _createElementBlock("form", {
        key: 0,
        ref: "form",
        action: $options.actionUrl,
        method: "post",
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createElementVNode("input", {
          type: "hidden",
          name: "returnUrl",
          value: $options.returnUrl
        }, null, 8 /* PROPS */, _hoisted_2),
        _createElementVNode("input", {
          value: $options.currentProjectCurrencyID,
          type: "hidden",
          name: "projectCurrencyID"
        }, null, 8 /* PROPS */, _hoisted_3),
        _renderSlot(_ctx.$slots, "default"),
        _createVNode(_component_click_outside, { call: $options.onClickOutside }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: _normalizeClass(['gfu-currency-selector__select', {'is-expanded': _ctx.isDropdownExpanded}])
              }, [
                _createElementVNode("button", {
                  tabindex: "0",
                  class: "gfu-currency-selector__label",
                  onClick: _cache[0] || (_cache[0] = (...args) => ($options.onClickLabel && $options.onClickLabel(...args))),
                  "data-qa": "currency-selector:SelectedCurrency"
                }, [
                  _createTextVNode(_toDisplayString(_ctx.currentCurrency.shortName) + " ", 1 /* TEXT */),
                  _createVNode(_component_base_icon, {
                    name: "chevron-down",
                    class: "_tc--accent",
                    "aria-hidden": "true"
                  })
                ]),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.currentSelectedCurrencyId) = $event)),
                  name: "currency",
                  autocomplete: "off",
                  onChange: _cache[2] || (_cache[2] = (...args) => ($options.onChange && $options.onChange(...args)))
                }, [
                  _createElementVNode("optgroup", {
                    label: _ctx.Resources.ProjectHome.ProjectCurrenciesLabel
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checkoutCurrencies, (checkoutCurrency) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: checkoutCurrency.currencyID,
                        value: checkoutCurrency.currencyID,
                        selected: _ctx.currentCurrency.currencyID === checkoutCurrency.currencyID || null
                      }, _toDisplayString(checkoutCurrency.shortName), 9 /* TEXT, PROPS */, _hoisted_6))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 8 /* PROPS */, _hoisted_5),
                  ($options.hasDisplayCurrencies)
                    ? (_openBlock(), _createElementBlock("optgroup", {
                        key: 0,
                        label: _ctx.Resources.ProjectHome.DisplayCurrenciesLabel
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayCurrencies, (displayCurrency) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: displayCurrency.currencyID,
                            value: displayCurrency.currencyID,
                            selected: _ctx.currentCurrency.currencyID === displayCurrency.currencyID || null
                          }, _toDisplayString(displayCurrency.shortName), 9 /* TEXT, PROPS */, _hoisted_8))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 8 /* PROPS */, _hoisted_7))
                    : _createCommentVNode("v-if", true)
                ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                  [_vModelSelect, _ctx.currentSelectedCurrencyId]
                ])
              ], 2 /* CLASS */),
              _createVNode(_Transition, { name: "gfu-fade" }, {
                default: _withCtx(() => [
                  (_ctx.isDropdownExpanded)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        ($options.hasDisplayCurrencies)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.Resources.ProjectHome.ProjectCurrenciesLabel), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checkoutCurrencies, (checkoutCurrency) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: checkoutCurrency.currencyID,
                            class: _normalizeClass(['gfu-currency-selector-option', {'is-selected': _ctx.currentCurrency.currencyID === checkoutCurrency.currencyID}]),
                            tabindex: "0",
                            role: "option",
                            onClick: $event => ($options.setCurrentSelectedCurrencyID(checkoutCurrency.currencyID)),
                            onKeydown: _withKeys(_withModifiers($event => ($options.setCurrentSelectedCurrencyID(checkoutCurrency.currencyID)), ["prevent"]), ["enter"]),
                            "data-qa": `currency-selector-project-currency:${checkoutCurrency.currencyID}`
                          }, _toDisplayString(checkoutCurrency.name) + " - " + _toDisplayString(checkoutCurrency.shortName) + " (" + _toDisplayString(checkoutCurrency.symbol) + ") ", 43 /* TEXT, CLASS, PROPS, NEED_HYDRATION */, _hoisted_11))
                        }), 128 /* KEYED_FRAGMENT */)),
                        ($options.hasDisplayCurrencies)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.Resources.ProjectHome.DisplayCurrenciesLabel), 1 /* TEXT */),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayCurrencies, (displayCurrency) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: displayCurrency.currencyID,
                                  class: _normalizeClass(['gfu-currency-selector-option', {'is-selected': _ctx.currentCurrency.currencyID === displayCurrency.currencyID}]),
                                  tabindex: "0",
                                  role: "option",
                                  onClick: $event => ($options.setCurrentSelectedCurrencyID(displayCurrency.currencyID)),
                                  onKeydown: _withKeys(_withModifiers($event => ($options.setCurrentSelectedCurrencyID(displayCurrency.currencyID)), ["prevent"]), ["enter"]),
                                  "data-qa": `currency-selector-display-currency:${displayCurrency.currencyID}`
                                }, _toDisplayString(displayCurrency.name) + " - " + _toDisplayString(displayCurrency.shortName) + " (" + _toDisplayString(displayCurrency.symbol) + ") ", 43 /* TEXT, CLASS, PROPS, NEED_HYDRATION */, _hoisted_13))
                              }), 128 /* KEYED_FRAGMENT */))
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true)
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
              })
            ])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["call"]),
        _createVNode(_component_change_display_currency_modal, {
          "is-visible": _ctx.isCurrencyModalVisible,
          currency: $options.selectedCurrency,
          onAccept: $options.onAccept,
          onCancel: $options.onCancel
        }, null, 8 /* PROPS */, ["is-visible", "currency", "onAccept", "onCancel"])
      ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_1))
    : _createCommentVNode("v-if", true)
}